import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { loadTopCities } from './utils';

export default function* listenLoadTopCities() {
  yield takeEvery(homeActions.loadTopCities.toString(), loadTopCities);
}
